// import {useState} from "react";
// import CountUp from 'react-countup';
// import VisibilitySensor from "react-visibility-sensor";
// import css from "./EmptyOne.less";
import React from "react";
import PropTypes from 'prop-types';


const EmptyTwo = (props) => {
    // const [didViewCountUp, setDidViewCountUp] = useState(false);
    // const onVisibilityChange = isVisible => {
    //     if (isVisible) {
    //     setDidViewCountUp(true);
    //     }
    // };
    return (
        <div className="section section-padding-top about-section-padding-bottom-200">
            <div className="container">
                <div className="row">
                {props.children}

                </div>
            </div>
        </div>
    )
}

EmptyTwo.propTypes = {
    children: PropTypes.string
};

export default EmptyTwo;


// export default class EmptyTwo extends React.Component{
// 	constructor(props){
// 		super(props);
// 	}
// 	render()
// 	{
// 		return (
// 			<div className="section section-padding-top about-section-padding-bottom-200">
// 				<div className="container">
// 					<div className="row">
// 						{this.props.children}
						
// 					</div>
	
// 				</div>
// 			</div>
// 		)
// 	}
// }